const SEO_FILTER_FEATURES =
    Object.freeze(
        {
            BODY_TYPE: {
                CURVY: 'Kurvig',
                VERY_CURVY: 'Sehr kurvig',
            },
            GENDER: {
                TRANS: 'Transsexuell'
            }
        }
    );

export default SEO_FILTER_FEATURES;
